module.exports = __webpack_public_path__ + "assets/img/5.afb7567e.png";